import getConfig from 'next/config';
import { useRef } from 'react';
import { handleTrack } from '../../../utils/tracker';
import { FileItrSection } from '../../income-tax/page-sections/file-itr-section/index';
import { StartForFreeBanner } from '../../income-tax/page-sections/start-for-free-section/start-for-free/index';
import { itrData } from '../../income-tax/static/data';
import { StickyCTA } from './StickyCTA';
import { Banner } from './banner';
import { offerCards, secondFoldOffers } from './bigFilingWeek.data';
import { OfferCard } from './offerCard';
import { SecondFoldOffer } from './secondFoldOffer';
const { publicRuntimeConfig } = getConfig();

export const BigFilingWeek = (): JSX.Element => {
  return (
    <div className="w-full">
      <Banner />
      <StickyCTA />
      <div className="wg-container">
        <div className="pt-14 sm:px-2.5 flex -mx-3 flex-wrap sm:pt-7 justify-center">
          {offerCards.map((card, idx) => {
            return <OfferCard {...card} key={idx} />;
          })}
        </div>
        <div className="py-14 sm:py-7">
          <img
            src="https://assets.clear.in/cleartax/images/1688652046_frame18142180451.png"
            alt="ad 2"
            className="sm:hidden"
          />
          <img
            src="https://assets.clear.in/cleartax/images/1688647133_androidsmall31.png"
            className="xl:hidden lg:hidden md:hidden"
            alt="ad 2"
          ></img>
        </div>
        <div className="pt-7 sm:py-7">
          <img
            src="https://assets.clear.in/cleartax/images/1689160969_30desktop.png"
            alt="ad 2"
            className="sm:hidden"
          />
          <img
            src="https://assets.clear.in/cleartax/images/1689160979_30mobile.png"
            className="xl:hidden lg:hidden md:hidden"
            alt="ad 2"
          ></img>
        </div>
        <div className="py-14 sm:py-7">
          <h3 className="text-s-48 text-font-500 sm:text-s-24">
            File your ITR in just 3 mins and win BIG rewards
          </h3>
          <div className="pt-12 flex flex-wrap">
            {secondFoldOffers.map((card, idx) => {
              return <SecondFoldOffer {...card} key={idx} />;
            })}
          </div>
        </div>
      </div>
      <FileItrSection
        data={itrData.itrSection}
        id={`file-itr`}
        name={'File with ClearTax?'}
        ref={useRef<HTMLDivElement>(null)}
        key={`file-itr`}
        isVariant={false}
      />
      <div className="wg-container pt-28 pb-20 md:pt-16 sm:py-16">
        <StartForFreeBanner
          heading="Still confused? Get Expert Assistance "
          desc="Get a dedicated expert to handle your taxes from start to finish"
          planData={{
            text: 'Our Plans starting from ',
            discountedPrice: '₹1699',
            originalPrice: '₹1999',
          }}
          button1={{
            text: 'View plans',
            url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/pricing`,
          }}
          priceMapData={{}}
        />
      </div>
      <div className="wg-container pb-20 sm:pb-16">
        <a
          href="https://www.youtube.com/watch?v=VS8Ol8NNC3g&list=PLQ8yz2TldKLKIYcMVuG4BoLUXL4wWP9mZ"
          data-testid="youtube-banner"
          onClick={(e) => {
            handleTrack({
              label: 'big-filing-day-page',
              url: 'https://www.youtube.com/watch?v=VS8Ol8NNC3g&list=PLQ8yz2TldKLKIYcMVuG4BoLUXL4wWP9mZ',
              obj: e.target,
            });
          }}
        >
          <img
            src="https://assets.clear.in/cleartax/images/1689161139_webinardesktop.png"
            alt="ad 2"
            className="sm:hidden rounded-xl"
          />
          <img
            src="https://assets.clear.in/cleartax/images/1689161004_webinarmobile.png"
            className="xl:hidden lg:hidden md:hidden rounded-xl"
            alt="ad 2"
          ></img>
        </a>
      </div>
    </div>
  );
};
